import SystemOptions from '../../utils/options';
import { processImageData } from '../collector';

export default function () {
  const options = SystemOptions.getInstance().getOptions();

  if (options.initPagePerformance && options.getResourcePerformance) {
    // 获取页面上已经存在图片的加载数据
    const imgList = Array.from(document.querySelectorAll('body img'));
    for (const img of imgList) {
      const src = img.getAttribute('src');
      if (src && window.performance.getEntriesByName(src).length === 0) {
        processImageData(img, src, options);
      }
    }

    // 获取页面上新增加的图片的加载数据
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length === 0) {
          return;
        }
        const addedNodes = Array.from(mutation.addedNodes);
        for (const nodeItem of addedNodes) {
          if (nodeItem.nodeType !== Node.ELEMENT_NODE) {
            continue;
          }
          if (nodeItem.nodeName === 'IMG') {
            const src = (nodeItem as Element).getAttribute('src');
            src && processImageData(nodeItem, src, options, true);
          } else {
            const subImgList = Array.from((nodeItem as Element).querySelectorAll('img'));
            if (subImgList.length === 0) {
              return;
            }
            for (const img of subImgList) {
              const src = img.getAttribute('src');
              src && processImageData(img, src, options, true);
            }
          }
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
    });
  }
}
